const TooltipClass = {
	HIDE: `hide`,
	VISIBLE: `hover`,
};

const TOP_SHIFT = 2;

const showTooltip = (tooltip) => {
	tooltip.classList.remove( TooltipClass.HIDE );
	tooltip.classList.add( TooltipClass.VISIBLE );
};

const hideTooltip = (tooltip) => {
	tooltip.classList.add( TooltipClass.HIDE );
	tooltip.classList.remove( TooltipClass.VISIBLE );
};

const setTooltipPosition = (container, layout, tooltip, node) => {
	const containerPos = container.getBoundingClientRect();
	const layoutPos = layout.getBoundingClientRect();
	const nodePos = node.getBoundingClientRect();
	const tooltipPos = tooltip.getBoundingClientRect();
	
	const bottomBorder = (layoutPos.y - containerPos.y) + layoutPos.height;
	const rightBorder = (layoutPos.x - containerPos.x) + layoutPos.width;
	
	let tooltipTop = (nodePos.y - containerPos.y) + nodePos.height;
	let tooltipBottom = tooltipTop + tooltipPos.height;
	let tooltipLeft = (nodePos.x - containerPos.x);
	let tooltipRight = tooltipLeft + tooltipPos.width;
	
	if ( tooltipBottom > bottomBorder ) {
		tooltipTop = tooltipTop - tooltipPos.height - nodePos.height;
	}
	
	if ( tooltipRight > rightBorder ) {
		tooltipLeft = tooltipLeft - tooltipPos.width + nodePos.width;
	}
	
	tooltip.style.top = tooltipTop + `px`;
	tooltip.style.left = tooltipLeft + `px`;
};

export {
	showTooltip,
	hideTooltip,
	setTooltipPosition,
};
